import React, { forwardRef } from 'react'
import { motion, cubicBezier } from 'framer-motion'
import { UnstyledButton, styled, ScreenReaderOnly } from '@chilipiper/design-system'
import { BackgroundCircle } from './BackgroundCircle'
import { LoopedBlob } from './LoopedBlob'
import { BlotToChat } from './BlobToChat'

interface Props {
  onClick: () => void
}

export const BotLauncher = forwardRef<HTMLButtonElement, Props>(({ onClick }: Props, ref) => {
  return (
    <StyledButton ref={ref} data-test-id='BotLauncher' onClick={onClick}>
      <motion.svg
        width={75}
        height={75}
        viewBox='0 0 75 75'
        style={{ originX: 'center', originY: 'center' }}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{
          duration: 0.3,
          ease: cubicBezier(0.25, 0.1, 0.25, 1),
        }}
      >
        <BackgroundCircle />
        <LoopedBlob />
        <BlotToChat />
      </motion.svg>
      <ScreenReaderOnly>Open chat</ScreenReaderOnly>
    </StyledButton>
  )
})
const StyledButton = styled(UnstyledButton)`
  width: 75px;
  height: 75px;
`
